<template>
    <div>
      صفحه مورد نظر شما وجود ندارد
      تا چند ثانیه دیگر به صفحه اصلی منتقل میشوید
    </div>
</template>

<script>
export default {
  name: 'PageNotFound',
  mounted () {
    setTimeout(() => {
      this.$router.replace({ name: 'home' })
    }, 2000)
  }
}
</script>

<style scoped>

</style>
